import { BorderRadius, Color, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const InvoiceSummaryContent = styled.div`
  width: 288px;
  padding: ${Spacing.S16};
  border-radius: ${BorderRadius.R16};
  background-color: ${Color.Grey50};
`
